import { CarsWidgetListProps } from 'features/cars-widget/types'
import { createMediaStyles } from 'lib/styled-helpers'
import React, { FC, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { Button } from 'ui/button'
import { CarCardsList } from 'ui/car-cards-list'
import { Cell } from 'ui/grid'
import { SkeletonCard } from 'ui/skeleton-card'

import { getProjectName } from '../../../../lib/get-project-name'
import { useCarsForWidget } from '../../useCarsForWidget'

export const CarsWidgetList: FC<CarsWidgetListProps> = (props) => {
  const { cars, loadNextPage, pagesLoaded, totalCount, fetching } = useCarsForWidget(props)

  const skeletons = useMemo(() => {
    const pageSize = props?.pageLength || 25
    const imageRatio = props?.carViewSettings.images.ratio || { x: 16, y: 9 }
    return Array.from({ length: pageSize }, (_, i) => {
      return (
        <Cell size={12} phablet={6} tablet={4} projectors={3} key={i} gutters={true}>
          <SkeletonCard ratio={imageRatio} />
        </Cell>
      )
    })
  }, [])

  useEffect(() => {
    /*Очистка памяти*/
    return () => {}
  }, [])

  return (
    <>
      <CarCardsList
        carViewSettings={props?.carViewSettings}
        useSmartContract={false}
        showSkeletons={fetching}
        cars={cars}
        skeletons={skeletons}
        cardSize={{ size: 12, phablet: 6, tablet: 4, projectors: 3 }}
        emptyText={props?.emptyText}
        openCardsLinksInNewTab={props?.openCardsLinksInNewTab}
      />
      {props?.pageLength && pagesLoaded * props?.pageLength < totalCount && cars && cars?.length > 0 && (
        <ButtonWrapper>
          <Button
            onClick={() => loadNextPage()}
            size="big"
            customSize={getProjectName() === 'sollers' ? '46px' : null}
            disabled={fetching}
          >
            <ButtonText>{props?.moreBtn}</ButtonText>
          </Button>
        </ButtonWrapper>
      )}
    </>
  )
}

const Wrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing[16]} ${theme.spacing[0]}`};
  background: #ebebeb;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: ${({ theme }) => theme.spacing[10]};

  ${({ theme }) =>
    createMediaStyles(() => ({
      tablet: `width: ${theme.spacing[80]};`
    }))};
`

const ButtonText = styled.span`
  text-transform: uppercase;
`
